import { render, staticRenderFns } from "./NewOrderDetail.vue?vue&type=template&id=1cfc1eb1&"
import script from "./NewOrderDetail.vue?vue&type=script&lang=js&"
export * from "./NewOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports